import { createFileRoute, redirect } from "@tanstack/react-router";

import { meterApi } from "~/api";
import { firstMainMeter } from "~/features/consumption";
import { m } from "~/paraglide/messages";

export const Route = createFileRoute("/_authenticated/buildings_/$buildingId/consumption/")({
  loader: async ({ context: { queryClient }, params: { buildingId } }) => {
    const meter = firstMainMeter(await queryClient.ensureQueryData(meterApi.queries.building(buildingId)));
    if (meter) {
      throw redirect({
        to: "/buildings/$buildingId/consumption/$meterId",
        params: { buildingId, meterId: meter.id },
        search: true,
        replace: true,
      });
    }
  },
  component: ConsumptionIndex,
});

function ConsumptionIndex() {
  return <p className="text-primary-dark-gray">{m.no_result()}</p>;
}
